import { useLanguage } from "@/context/LanguageContext";
import { useEffect, useState } from "react";
import { api } from "@/services/apiClient";

const FALLBACK = [
  { code: "BR", name: "Brasil", dial: "+55", flag: "🇧🇷" },
  { code: "PT", name: "Portugal", dial: "+351", flag: "🇵🇹" },
  { code: "CY", name: "Chipre", dial: "+357", flag: "🇨🇾" },
  { code: "ES", name: "Espanha", dial: "+34", flag: "🇪🇸" },
  { code: "IT", name: "Itália", dial: "+39", flag: "🇮🇹" },
  { code: "GR", name: "Grécia", dial: "+30", flag: "🇬🇷" },
  { code: "GB", name: "Inglaterra", dial: "+44", flag: "🇬🇧" },
];

export const useCountries = () => {
  const [countries, setCountries] = useState(FALLBACK);
  useEffect(() => {
    api.get("/auth/countries").then(({ data }) => data?.length && setCountries(data)).catch(() => {});
  }, []);
  return countries;
};

export const PhoneField = ({ dial, phone, onDial, onPhone, testIdPrefix = "phone", required }) => {
  const countries = useCountries();
  const country = countries.find((c) => c.dial === dial);
  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <select
          data-testid={`${testIdPrefix}-dial-select`}
          value={dial}
          onChange={(e) => onDial(e.target.value)}
          className="h-12 w-36 rounded-md border border-[#22252F] bg-[#0F1116] px-2 text-sm text-white"
        >
          {countries.map((c) => (
            <option key={c.code} value={c.dial}>{c.flag} {c.dial}</option>
          ))}
        </select>
        <input
          data-testid={`${testIdPrefix}-number-input`}
          required={required}
          inputMode="numeric"
          value={phone}
          onChange={(e) => onPhone(e.target.value.replace(/\D/g, ""))}
          placeholder="Número sem indicativo"
          className="h-12 flex-1 rounded-md border border-[#22252F] bg-[#0F1116] px-3 text-sm text-white placeholder:text-[#4B5563]"
        />
      </div>
      <p data-testid={`${testIdPrefix}-country-hint`} className="text-xs text-[#94A3B8]">
        {country ? `${country.flag} ${country.name} · ${country.dial}` : "Selecione o indicativo do país"}
      </p>
    </div>
  );
};

export const ModeToggle = ({ mode, onChange, testIdPrefix = "auth" }) => {
  const { t } = useLanguage();
  return (
  <div className="flex gap-2 rounded-md border border-[#22252F] bg-[#0F1116] p-1">
    {[
      { key: "email", labelKey: "auth.email" },
      { key: "phone", labelKey: "auth.phone" },
    ].map((m) => (
      <button
        key={m.key}
        type="button"
        data-testid={`${testIdPrefix}-mode-${m.key}`}
        onClick={() => onChange(m.key)}
        className={`flex-1 rounded px-3 py-2 text-xs uppercase tracking-[0.15em] transition-colors ${
          mode === m.key ? "bg-[#2563EB] text-white" : "text-[#94A3B8] hover:text-white"
        }`}
      >
        {t(m.labelKey)}
      </button>
    ))}
  </div>
  );
};
